var render, staticRenderFns
import script from "./picker-editboard.vue?vue&type=script&lang=js"
export * from "./picker-editboard.vue?vue&type=script&lang=js"
import style0 from "./picker-editboard.vue?vue&type=style&index=0&id=b07edfbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports